var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExternalLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.586 3.39734H16C15.448 3.39734 15 2.94934 15 2.39734C15 1.84534 15.448 1.39734 16 1.39734H22C22.552 1.39734 23 1.84534 23 2.39734V8.39734C23 8.94934 22.552 9.39734 22 9.39734C21.448 9.39734 21 8.94934 21 8.39734V4.81134L11.707 14.1043C11.316 14.4953 10.683 14.4953 10.293 14.1043C9.903 13.7133 9.902 13.0803 10.293 12.6903L19.586 3.39734ZM18 12.3973C18 11.8453 18.448 11.3973 19 11.3973C19.552 11.3973 20 11.8453 20 12.3973V18.3973C20 20.0543 18.657 21.3973 17 21.3973H6C4.343 21.3973 3 20.0543 3 18.3973V7.39734C3 5.74034 4.343 4.39734 6 4.39734H12C12.552 4.39734 13 4.84534 13 5.39734C13 5.94934 12.552 6.39734 12 6.39734H6C5.448 6.39734 5 6.84534 5 7.39734V18.3973C5 18.9493 5.448 19.3973 6 19.3973H17C17.552 19.3973 18 18.9493 18 18.3973V12.3973Z",
    fill: "#0078AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink);
export default __webpack_public_path__ + "static/media/external-link.cd52b311b2c8c338319ba6f00394e4fb.svg";
export { ForwardRef as ReactComponent };